import React, { useEffect, useRef, useState } from "react";
import { getReferentielDataFromServer } from "../general/AxiosReferencielInterceptor";
import PTCircular from "./PTCircular";

export const PTDocumentViewer = ({ guid, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [documentUrl, setDocumentUrl] = useState(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    const fetchDocument = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await getReferentielDataFromServer(
          false,
          `/api/document/${guid}`,
          {},
          "post",
          { responseType: "arraybuffer" }
        );

        const blob = new Blob([response], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        
        setDocumentUrl(url);
        setLoading(false);
      } catch (err) {
        console.error("Document fetch error:", err);
        setError(err instanceof Error ? err.message : "Failed to load document");
        setLoading(false);
      }
    };

    fetchDocument();

    // Cleanup: Revoke blob URL
    return () => {
      if (documentUrl) {
        URL.revokeObjectURL(documentUrl);
      }
    };
  }, [guid]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <PTCircular 
      isCircul={loading}
      minHeight="85vh"
      minWidth="104vh"
    >
      {documentUrl && (
        <iframe
        ref={iframeRef}
        src={`${documentUrl}#view=fitH&toolbar=1&navpanes=0`}
        title="document-viewer"
        width="700px"
        height="650px"
        style={{
          border: "none",
          display: loading ? "none" : "block",
          visibility: loading ? "hidden" : "visible",
        }}
      />
      
      )}
    </PTCircular>
  );
};

export default PTDocumentViewer;